import { render, staticRenderFns } from "./AccountPartnerInfo.vue?vue&type=template&id=8f96cd4c&scoped=true&"
import script from "./AccountPartnerInfo.vue?vue&type=script&lang=js&"
export * from "./AccountPartnerInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccountPartnerInfo.vue?vue&type=style&index=0&id=8f96cd4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f96cd4c",
  null
  
)

export default component.exports